'use strict';

/*!
 * ignore
 */

module.exports = function(val) {
  if (typeof val !== 'number' && typeof val !== 'string') {
    throw new Error('$type parameter must be number or string');
  }

  return val;
};



//////////////////
// WEBPACK FOOTER
// ./~/mongoose/lib/schema/operators/type.js
// module id = 461
// module chunks = 0